<template>
  <div class="container wc-container wc-container-720">
    <Card>
      <Form>
        <div class="fields" v-for="field in fields.data">
          <reg-form-item :data="field" />
        </div>

        <Button @click="addNewFieldModalChangeVisibility(true)">
          <Icon type="ios-plus" />New Field
        </Button>
      </Form>
    </Card>

    <!-- addNewFieldModal -->
    <Modal
      :value="addNewFieldModalSettings.show"
      title="Add New Field"
      @on-ok="addNewField"
      @on-cancel="addNewFieldModalChangeVisibility(false)"
      width="640"
    >
      <Form :model="addNewFieldFormData">
        <FormItem label="Field Name">
          <Input v-model="addNewFieldFormData.name" required />
        </FormItem>

        <FormItem label="Help Text">
          <vue-editor
            id="helpTextEditor"
            v-model="addNewFieldFormData.helpText"
            style="margin-top: 32px"
            :editorToolbar="helpTextEditorOptions"
          />
        </FormItem>

        <FormItem label="Type">
          <Select
            v-model="addNewFieldFormData.fieldType"
            placeholder="Please select one"
            required
          >
            <Option
              v-for="(value, key) in fieldTypes"
              :value="key"
              :key="key"
              >{{ value }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          label="Selectbox Options"
          v-if="addNewFieldFormData.fieldType == 'selectbox'"
        >
          <Input v-model="addNewFieldFormData.selectBoxOptions" />
        </FormItem>
        <FormItem v-if="addNewFieldFormData.fieldType == 'selectbox'">
          <Checkbox v-model="addNewFieldFormData.selectBoxUseOther">
            Add
            <b>Other</b> option
          </Checkbox>
        </FormItem>
        <FormItem v-else-if="addNewFieldFormData.fieldType === 'html_content'">
          <vue-editor v-model="addNewFieldFormData.htmlContent" />
        </FormItem>

        <FormItem>
          <Checkbox v-model="addNewFieldFormData.required">Required</Checkbox>
        </FormItem>
      </Form>

      <div slot="footer">
        <Button type="success" @click="addNewField">Add</Button>
        <Button type="default" @click="addNewFieldModalChangeVisibility(false)"
          >Close</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { VueEditor } from 'vue2-editor'
import RegFormItem from './RegFormItem.vue'

export default {
  data() {
    return {
      helpTextEditorOptions: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link']
      ],
      addNewFieldFormData: {
        webcastId: '',
        name: '',
        helpText: '',
        fieldType: '',
        required: false
      },
      fieldTypes: {
        name: 'Name',
        name6: 'Name 6',
        last_name: 'Last Name',
        email: 'Email',
        city: 'City',
        country: 'Country',
        phone: 'Phone',
        event_password: 'Event Password',
        email_permission: 'Email Permission',
        short_text: 'Short Text',
        long_text: 'Long Text',
        number: 'Number',
        checkbox: 'Checkbox',
        selectbox: 'Select Box',
        birth_year: 'Birth Year',
        tcid: 'TC ID CUSTOM',
        tcidf: 'TC ID CUSTOM2',
        html_content: 'HTML Content'
      },
      addNewFieldFormDataOrigin: {},
      addNewFieldModalSettings: { show: false }
    }
  },
  computed: {
    ...mapGetters('reg-form', { fieldsInStore: 'find' }),
    fields() {
      return this.fieldsInStore({ query: {} })
    }
  },
  methods: {
    ...mapActions('reg-form', {
      createRegFormAction: 'create',
      getRegFormAction: 'find'
    }),

    addNewFieldModalChangeVisibility(isVisible = true) {
      this.addNewFieldModalSettings.show = isVisible
      this.addNewFieldFormData = _.cloneDeep(this.addNewFieldFormDataOrigin)
    },

    setDefaultNewFieldData() {
      this.addNewFieldFormDataOrigin = _.cloneDeep(this.addNewFieldFormData)
    },

    addNewField() {
      this.$set(
        this.addNewFieldFormData,
        'webcastId',
        this.$router.currentRoute.params.id
      )

      this.createRegFormAction(this.addNewFieldFormData).then(response => {
        console.log(response)
      })

      this.addNewFieldModalChangeVisibility(false)
    }
  },
  components: {
    RegFormItem,
    VueEditor
  },
  created() {
    this.getRegFormAction({
      query: { webcastId: this.$router.currentRoute.params.id }
    }).then(response => {
      console.log(response)
    })

    this.setDefaultNewFieldData()
  }
}
</script>
<style lang="scss">
.ql-editor {
  min-height: 120px;
}
.ivu-checkbox-wrapper {
  font-size: 14px !important;
}
</style>
